// extracted by mini-css-extract-plugin
module.exports = {"projectCardInfo":"ProjectCardInfo_projectCardInfo__3RaJ3"};